import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPeepsBook = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 20 21",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M3 5.226a2.75 2.75 0 0 1 2.75-2.75h9A2.249 2.249 0 0 1 17 4.726v8c0 .781-.397 1.469-1 1.872v2.378h.25c.416 0 .75.334.75.75s-.334.75-.75.75H5.5a2.5 2.5 0 0 1-2.5-2.5V5.226Zm1.5 10.75a1 1 0 0 0 1 1h9v-2h-9a1 1 0 0 0-1 1Zm0-2.29a2.47 2.47 0 0 1 1-.21h9.25c.416 0 .75-.334.75-.75v-8a.748.748 0 0 0-.75-.75h-9c-.69 0-1.25.56-1.25 1.25v8.46Zm4-6.21a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm-.594 4.25c-.462 0-.818-.428-.562-.812a2.086 2.086 0 0 1 1.74-.938h1.835a2.08 2.08 0 0 1 1.74.938c.253.384-.1.812-.562.812H7.906Z" })
});
export default SvgPeepsBook;
